// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"43df4d5c","338":"ded8b7c5","741":"85b97008"}[chunkId] + ".chunk.css";
};